import { SalesHistorySummary } from "./sales-history-summary";
import { CompanySalesHistoryItem } from "./company-sales-history-item";
import { PagingInfo } from "../../paginator/paging-info.model";

export class SalesHistoryCompany {
  private pagingInfo: PagingInfo;
  private fiscalNumber: string;
  private corporateName: string;
  private employeeCount: number;
  private salesHistorySummary: SalesHistorySummary;
  private companySalesHistoryItemList: CompanySalesHistoryItem[];

  setPagingInfo(value: PagingInfo): void {
    this.pagingInfo = value;
  }

  getPagingInfo(): PagingInfo {
    return this.pagingInfo;
  }

  setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  setCorporateName(value: string): void {
    this.corporateName = value;
  }

  getCorporateName(): string {
    return this.corporateName;
  }

  setEmployeeCount(value: number): void {
    this.employeeCount = value;
  }

  getEmployeeCount(): number {
    return this.employeeCount;
  }

  setSalesHistorySummary(value: SalesHistorySummary): void {
    this.salesHistorySummary = value;
  }

  getSalesHistorySummary(): SalesHistorySummary {
    return this.salesHistorySummary;
  }

  setcompanySalesHistoryItemList(value: CompanySalesHistoryItem[]): void {
    this.companySalesHistoryItemList = value;
  }

  getcompanySalesHistoryItemList(): CompanySalesHistoryItem[] {
    return this.companySalesHistoryItemList;
  }

  addItems(items: CompanySalesHistoryItem[]): void {
    this.companySalesHistoryItemList = this.companySalesHistoryItemList.concat(items);
  }
}
